import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-select--block-placeholder" }
const _hoisted_2 = { class: "color-text-primary caption-medium" }
const _hoisted_3 = { class: "base-select--block-arrow color-grey-light" }
const _hoisted_4 = ["onClick"]

import { ref, onMounted } from "vue";
import { PropType } from "@vue/runtime-core";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSelect',
  props: /*@__PURE__*/_mergeModels({
  placeholder: {
    type: String,
    default: "",
  },
  items: Array as PropType<string[]>,
}, {
    "modelValue": {
  default: "",
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const { t } = useI18n();

const props = __props;

const selectValue = _useModel<string>(__props, "modelValue");

const activeState = ref<boolean>(false);
const activeItem = ref<string>("");

const chooseItem = (item: string) => {
  activeItem.value = item;
  activeState.value = false;
  selectValue.value = item;
};

onMounted(() => {
  activeItem.value = props.placeholder || t("base.select.placeholder");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-select", { active: activeState.value }])
  }, [
    _createElementVNode("div", {
      class: "base-select--block",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (activeState.value = !activeState.value))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(activeItem.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseIcon, {
          name: "service-arrow",
          position: activeState.value ? 'top' : 'bottom'
        }, null, 8, ["position"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["base-select--drop", { active: activeState.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "base-select--drop-item",
          onClick: ($event: any) => (chooseItem(item))
        }, _toDisplayString(item), 9, _hoisted_4))
      }), 128))
    ], 2)
  ], 2))
}
}

})